<template>
    <div>
        <Hero />

        <div class="p-8 md:p-20">
            <!-- <div class="text-xl mt-3 flex flex-col gap-y-4">
                <p>Our mission is to help growing children learn God's word in its truth and simplicity.</p>
                <p>We aim to help raise Godly children who understand the gospel of Jesus and need to commit to the service of the same.</p>
                <p>Through our Bible club meetings every Sunday evening, we train children who can boldly preach the gospel, defend the message of salvation, and live a victorious life in Christ Jesus marked by supernatural experiences and manifestation of the spirit of God.</p>
            </div> -->

            <div class="grid lg:grid-cols-2 mt-5 gap-3 place-items-center">
                <div>
                    <div class="uppercase font-bold text-xl">About</div>
                    <div class="text-xl mt-3 flex flex-col gap-y-4">
                        <p>Our mission is to help growing children learn God's word in its truth and simplicity.</p>
                        <p>We aim to help raise Godly children who understand the gospel of Jesus and need to commit to the service of the same.</p>
                        <p>Through our Bible club meetings every Sunday evening, we train children who can boldly preach the gospel, defend the message of salvation, and live a victorious life in Christ Jesus marked by supernatural experiences and manifestation of the spirit of God.</p>
                    </div>
                    <!-- <img src="../assets/images/placeholder.jpg" alt="" class="w-full"> -->
                </div>
                <div>
                    <img src="../assets/images/bible_club.jpg" alt="" class="w-full rounded">
                </div>
            </div>

            <RouterLink to="/give" class="mt-10 flex justify-center">
                <SecondaryButton content="support the work" />
            </RouterLink>
        </div>

        <BecomeOurFamily/>

        <BottomLinks />
    </div>
</template>

<script setup>
import Hero from '../components/Bible_Club/Hero.vue';
import SecondaryButton from '../components/SecondaryButton.vue'
import BecomeOurFamily from '../components/BecomeOurFamily.vue';
import BottomLinks from '../components/Bible_Club/BottomLinks.vue';
</script>

<style scoped>

</style>